import { ReactNode, useMemo, useState } from 'react'
import { PRIVATE_ROUTES } from 'routes'
import { AuthUser, RoutesMap } from 'ts/types'
import { filterRoutesByRole } from 'ts/utils'
import { AuthContext } from './AuthContext'

const STORAGE_KEY = 'authUser'

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<AuthUser | null>(() => {
    const storedUser = localStorage.getItem(STORAGE_KEY)
    return storedUser ? JSON.parse(storedUser) : null
  })

  const saveUser = (userData: AuthUser) => {
    setUser(userData)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(userData))
  }

  const clearUser = () => {
    setUser(null)
    localStorage.removeItem(STORAGE_KEY)
    localStorage.removeItem('selectedEstimate')
    localStorage.removeItem('initialFilters')
  }

  const isLoggedIn = () => {
    const currentTime = Date.now()
    const expirationTime = user?.expirationTime || 0
    return currentTime < expirationTime
  }

  const allowedRoutes = useMemo(() => {
    if (user && user.role) {
      return filterRoutesByRole(PRIVATE_ROUTES, user.role)
    }
    return {} as RoutesMap
  }, [user])

  return (
    <AuthContext.Provider value={{ user, saveUser, clearUser, isLoggedIn, allowedRoutes }}>
      {children}
    </AuthContext.Provider>
  )
}
